import { EllipsisVerticalIcon } from '@w/ui/components/icon'
import { IconButton } from '@w/ui/components/icon-button'
import { Menu, MenuTrigger, MenuPopup, MenuItem } from '@w/ui/components/menu'

export function PressActionMenu({ testId, label, actions }: { testId: string; label: string; actions: { id: string; label: string; disabled?: boolean; run: () => void }[] }) {
  return <Menu><MenuTrigger data-testid={testId} render={<IconButton aria-label={label} size="sm" />}><EllipsisVerticalIcon />{label}</MenuTrigger><MenuPopup>{actions.map(action => <MenuItem key={action.id} data-testid={action.id} disabled={action.disabled} onClick={action.run}>{action.label}</MenuItem>)}</MenuPopup></Menu>
}
